import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasBreadcrumbsComponent } from './gas-breadcrumbs.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

const COMPONENTS = [
  GasBreadcrumbsComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,

    GasIconsModule,
  ],
})
export class GasBreadcrumbsModule { }
